<template>
  <div id="vote_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區投票列表
          </div>
          <div class="tip">
            假文案待補充
          </div>
        </div>
      </div>
      <filter-frame
        ref="filter"
        :save-filter="true"
        :filter-form="depositFilter"
        @search="search"
        @clear="clearSearch()"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <el-button
            icon="icon-plus"
            round
            @click="$router.push({name:'voteEdit'})"
          >
            發起投票
          </el-button>
        </div>
      </div>
      <el-table
        class="votelist"
        :data="ListData"
        empty-text="目前無任何投票"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="Title"
          label="標題"
        >
          <template slot-scope="scope">
            <span
              class="news-title"
              @click.stop="goDetail(scope.row.Id)"
            >{{ scope.row.Title }}</span>
            <br>
            <span
              v-if="scope.row.IsImportant"
              class="tag important"
            >重要事務</span>
            <span
              v-if="scope.row.CanComment"
              class="tag canComment"
            >開放留言</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="投票者限制"
          width="110"
        >
          <template slot-scope="scope">
            {{ filterVoterType(scope.row.VoterType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="投票期間"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.StartTime.split(':')[0].replace('T', ' ') }}:{{ scope.row.StartTime.split(':')[1] }}
            <br>至<br>
            {{ scope.row.DueTime.split(':')[0].replace('T', ' ') }}:{{ scope.row.DueTime.split(':')[1] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="AlreadyVote"
          label="當前投票數量"
          width="110"
          align="center"
        />
        <el-table-column
          prop="Status"
          label="狀態"
          width="100"
        >
          <template slot-scope="scope">
            <span
              class="status"
              :class="filterIsCheck(scope.row).style"
            >{{ filterIsCheck(scope.row).text }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="操作"
          width="320"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="exportVote(scope.row)"
            >
              匯出
            </el-button>
            <template>
              <el-tooltip
                v-if="filterIsCheck(scope.row).text !== '投票中'"
                class="item"
                effect="dark"
                content="非投票期間不可再次推播給裝置"
                placement="top"
              >
                <el-button
                  size="mini"
                  class="disabled"
                  plain
                >
                  再通知
                </el-button>
              </el-tooltip>
              <el-button
                v-else
                size="mini"
                plain
                @click="notificationAgain(scope.row.Id)"
              >
                再通知
              </el-button>
            </template>
            <template>
              <el-button
                v-if="scope.row.IsCheck === 0"
                size="mini"
                plain
                @click="editVote(scope.row.Id)"
              >
                編輯
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="filterEditTooltip(scope.row)"
                placement="top"
              >
                <el-button
                  size="mini"
                  class="disabled"
                  plain
                >
                  編輯
                </el-button>
              </el-tooltip>
            </template>
            <template>
              <el-tooltip
                v-if="scope.row.IsCheck === 1"
                class="item"
                effect="dark"
                :content="filterDeleteTooltip(scope.row)"
                placement="top"
              >
                <el-button
                  type="danger"
                  size="mini"
                  class="disabled"
                  plain
                >
                  刪除
                </el-button>
              </el-tooltip>
              <el-button
                v-else
                type="danger"
                size="mini"
                plain
                @click="deleteVote(scope)"
              >
                刪除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'

import filterFrame from '@/components/FilterFrame'
export default {
  components: {
    'filter-frame': filterFrame,
    TableLoading
  },

  beforeRouteEnter (to, from, next) {
    if (from.name !== 'voteEdit' && from.name !== 'voteDetail') {
      sessionStorage.removeItem('filterData')
    } else {
      next(vm => {
        if (vm.$store.state.vote.edited) {
          vm.ListData = []
          vm.offset = 0
          vm.getList()
          vm.$store.commit('ifVoteEdit', false)
        } else {
          if (vm.$store.state.vote.height !== null) {
            vm.$nextTick(() => {
              document.documentElement.scrollTop = vm.$store.state.vote.height
            })
          }
        }
      })
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'voteDetail' && to.name !== 'voteEdit') {
      this.$store.commit('giveVoteHeight', null)
    }
    next()
  },
  data () {
    return {
      filter: {
        title: '',
        type: '',
        tag: [],
        start: '',
        due: ''
      },
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      depositFilter: [
        {
          label: '標題',
          name: 'title',
          type: 'input',
          rule: [{ min: 0, max: 100, message: '公告標題限定100字元', trigger: 'blur' }]
        },
        {
          label: '投票者限制',
          name: 'type',
          type: 'select',
          options: [
            {
              label: '一戶一票',
              value: 0
            },
            {
              label: '一人一票',
              value: 1
            }
          ],
          value: ''
        },
        {
          label: '標籤',
          name: 'tag',
          type: 'checkbox',
          options: [
            '重要事務',
            '開放留言'
          ]
        },
        {
          label: '時間',
          name: 'depositDate',
          type: 'date'
        }
      ],
      ListData: [],
      isSending: {
        export: false,
        notify: false
      }
    }
  },
  mounted () {
    if (!sessionStorage.getItem('filterData')) {
      this.getList()
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 查詢
    search (such_val) {
      this.filter = {
        title: such_val.title ? such_val.title : '',
        type: such_val.type !== undefined ? such_val.type : '',
        tag: such_val.tag ? such_val.tag : [],
        start: such_val.depositDate ? such_val.depositDate[0] : '',
        due: such_val.depositDate ? such_val.depositDate[1] : ''
      }
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 清除條件
    clearSearch () {
      this.filter = {
        title: '',
        type: '',
        tag: [],
        start: '',
        due: ''
      }
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 取得列表
    async getList (page = 1) {
      this.loading = true
      this.nowPage = page
      try {
        const res = await apiVote.Vote.GetVoteList({
          'Batch.Offset': this.offset,
          'Batch.MaxCount': this.maxCount,
          Title: this.filter.title,
          StartTime: this.filter.start,
          DueTime: this.filter.due,
          VoterType: this.filter.type,
          IsImportant: this.filter.tag.indexOf('重要事務') !== -1,
          CanComment: this.filter.tag.indexOf('開放留言') !== -1
        })
        await this.$sleep(1000, res.duration)
        this.ListData = this.ListData.concat(res.data.Data.Votings)
        this.loading = false
        this.scrollEnd = res.data.Data.Votings.length < 10
        return true
      } catch (err) {
        this.loading = false
        return false
      }
    },
    filterVoterType (type) {
      switch (type) {
      case 0:
        return '一戶一票'
      case 1:
        return '一人一票'
      }
    },
    filterIsCheck (vote) {
      switch (vote.IsCheck) {
      case 0:
        return {
          text: '已儲存',
          style: ''
        }
      case 1:
        if (new Date(vote.StartTime.replace('T', ' ').replace('Z', '')) > new Date()) {
          return {
            text: '待啟用',
            style: ''
          }
        } else {
          return {
            text: '投票中',
            style: 'success'
          }
        }
      case 2:
        return {
          text: '已關閉',
          style: 'danger'
        }
      }
    },
    filterEditTooltip (vote) {
      switch (vote.IsCheck) {
      case 1:
        if (new Date(vote.StartTime.replace('T', ' ').replace('Z', '')) > new Date()) {
          return '投票已發布囉，不可編輯囉！'
        } else {
          return '投票已開始囉，不可編輯囉！'
        }
      case 2:
        return '投票已結束，無法編輯囉！'
      }
    },
    filterDeleteTooltip (vote) {
      if (new Date(vote.StartTime.replace('T', ' ').replace('Z', '')) > new Date()) {
        return '投票已發布囉，不可刪除囉！'
      } else {
        return '投票已開始囉，不可刪除囉！'
      }
    },
    // 下拉到底自動載入
    handleScroll () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      if (ScrollTop + ClientHeight >= ScrollHeight - 20 &&
        !this.loading && this.$router.currentRoute.name === 'voteList') {
        if (!this.scrollEnd) {
          this.offset += this.maxCount
          this.$handleScroll(this.getList)
        }
      }
    },
    // 匯出投票
    exportVote (vote) {
      if (!this.isSending.export) {
        this.isSending.export = true
        const config = {
          responseType: 'blob'
        }
        apiVote.Vote.ExportVote({
          votingId: vote.Id
        }, config).then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName} ${vote.Title}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.isSending.export = false
        }).catch(err => {
          console.log(err)
          this.isSending.export = false
        })
      }
    },
    // 刪除投票
    deleteVote (row_data) {
      this.$confirm('是否刪除此項投票', '', {
        confirmButtonText: '刪除',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        apiVote.Vote.DeleteVote({
          VotingId: row_data.row.Id
        }).then(res => {
          this.ListData.splice(row_data.$index, 1)
          this.$message({
            type: 'success',
            message: '刪除成功'
          })
        }).catch(err => {
          console.log(err)
          this.$message({
            type: 'info',
            message: err.response
          })
        })
      }).catch(() => {
      })
    },
    // 再次通知
    notificationAgain (id) {
      if (!this.isSending.notify) {
        this.isSending.notify = true
        this.$confirm('是否通知？', '', {
          confirmButtonText: '確認',
          confirmButtonClass: 'el-button--success',
          cancelButtonText: '取消',
          closeOnClickModal: false
        }).then(action => {
          apiVote.Vote.NotificationAgain({
            votingId: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '通知成功'
            })
            this.isSending.notify = false
          }).catch(err => {
            console.log(err)
            this.$message({
              type: 'info',
              message: '通知失敗'
            })
            this.isSending.notify = false
          })
        }).catch(() => {
        })
      }
    },
    goDetail (Id) {
      this.$store.commit('giveVoteHeight', document.documentElement.scrollTop)
      this.$router.push({ name: 'voteDetail', params: { id: Id } })
    },
    editVote (Id) {
      this.$store.commit('giveNewsHeight', document.documentElement.scrollTop)
      this.$router.push({ name: 'voteEdit', params: { id: Id } })
    }
  }

}
</script>

<style lang="sass" scoped>
#vote_main
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
        text-align: left
    .title_bar.center
      margin: 20px 0 10px 0
    .votelist
      font-size: 15px
      .cell
        +NewsStatusTag
      .news-title
        cursor: pointer
        color: $mainColorDark
        text-decoration: underline
      ::v-deep .el-table
        +basicTable
      .status
        &.success
          color: $mainColor
        &.danger
          color: $dangerColor
      .tag
        margin-right: 5px
        &.important
          background-color: $warnColor
        &.canComment
          background-color: $infoColor
      .el-button.disabled
        opacity: 0.3
        cursor: default
        // pointer-events: none

.el-input__inner
  font-size: 15px !important
</style>
